var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login-mobile',{attrs:{"form-data-mapper":_vm.requestDataMapper,"submit-text":_vm.$t('scope.mobile_login_or_register')},on:{"after-login":_vm.handleAfterLogin}})
}
var staticRenderFns = []

export { render, staticRenderFns }